import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

let ID = 0;

@Component({
  selector: 'chitin-checkbox',
  templateUrl: './checkbox.component.html',
  imports: [FormsModule, CommonModule],
})
export class ChitinCheckboxComponent {
  @Input()
  inputId = `chitin-checkbox-${ID++}`;

  @Input()
  name?: string;

  @Input()
  mode: 'checkbox' | 'switch' | 'radio' = 'checkbox';

  @Input()
  size: 'medium' | 'large' = 'medium';

  @Input()
  disabled: boolean = false;

  @Input()
  reverse: boolean = false;

  @Input()
  label?: string;

  @Input()
  value?: boolean = false;

  @Output()
  valueChange = new EventEmitter<boolean>();
}
